import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconSvgComponent } from '../icon/icon.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'rx-applications-chip',
  standalone: true,
  imports: [CommonModule, IconSvgComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChipComponent), //tslint:disable-line
      multi: true,
    },
  ],
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
})
export class ChipComponent implements ControlValueAccessor {

  @Input() id: string;
  @Input() label: string;
  @Input() testIdPrefix = 'chip';

  @Output() remove = new EventEmitter<string>();

  removeChip($event: MouseEvent) {
    $event.preventDefault();
    this.remove.emit(this.id);
  }

  onChange = (_: unknown) => undefined;
  onTouch = (_: unknown) => undefined;

  writeValue(id: string): void {
    this.id = id;
  }

  registerOnChange(angularFunction): void {
    this.onChange = angularFunction;
  }

  registerOnTouched(angularFunction): void {
    this.onTouch = angularFunction;
  }
}
